import React, { useState } from 'react';
import { Pagination } from 'antd';
import './index.css';

interface CustomPaginationProps {
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number, pageSize: number) => void;
  onPageSizeChange: (pageSize: number, page: number) => void;
  pageSizeOptions?: number[];
  customClassName?: string;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
  total,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [5, 10, 20, 50],
  customClassName = '',
}) => {
  const [goToPage, setGoToPage] = useState<number | ''>('');
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  const totalPages = Math.ceil(total / pageSize);

  const handleGoToPage = () => {
    if (goToPage && goToPage >= 1 && goToPage <= totalPages) {
      onPageChange(goToPage, pageSize);
    }
  };

  return (
    <div className={`flex items-center justify-between py-1 page-number px-2 ${customClassName}`}>
      {/* Bên trái */}
      <div className='flex items-center gap-2 text-sm text-gray-600'>
        <span>
          ({start} đến {end} của {total})
        </span>
        <span>Số dòng mỗi trang:</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value), page)}
          className='border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500'
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      {/* Bên phải */}
      <div className='flex items-center gap-3'>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={total}
          onChange={onPageChange}
          showSizeChanger={false}
          className='custom-pagination'
        />
        <div className='flex items-center gap-1 text-sm text-gray-800'>
          <span>Đi đến</span>
          <input
            type='number'
            min={1}
            max={totalPages}
            value={goToPage}
            onChange={(e) =>
              setGoToPage(e.target.value ? Number(e.target.value) : '')
            }
            onKeyDown={(e) => e.key === 'Enter' && handleGoToPage()}
            className='w-16 border text-gray-800 border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500'
          />
          <span>trang</span>

          {/* <button
            onClick={handleGoToPage}
            className='px-2 py-1 bg-indigo-500 text-white rounded text-sm hover:bg-indigo-600'
          >
            Đi
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default CustomPagination;
